import { useLang } from '@/i18n';
import EfCardsA from '@elem/ui/ef-cards-a';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.ListA');
    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724137334148/a1-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724137339348/a1-h5.jpg',
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724137381214/a2-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724137385503/a2-h5.jpg',
            title: t('b_title'),
            desc: t('b_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724137414727/a3-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724137417323/a3-h5.jpg',
            title: t('c_title'),
            desc: t('c_desc'),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} />
            <EfCardsA list={listA} />
            <EfSpec />
        </div>
    );
}
